<template>
  <Dropdown class="profile-menu" trigger-class="profile-menu-toggle" dropdown-class="dropdown-list">
    <template #trigger>
      <div class="profile-menu-info">
        <Avatar
          :name="user.name"
          :pic="user.files_urls.avatar_thumbnail"
          :improve-url="false"
          squared
        />
        <div class="name-company">
          <div class="name-company__title">{{ name }}</div>
          <div class="small-text secondary">{{ active.name }}</div>
        </div>
        <div class="profile-menu-info__icon">
          <ChevronIcon class="icon-20px" />
        </div>
      </div>
    </template>
    <template #default="slotProps">
      <div
        class="drop-link w-dropdown-link pointer"
        @click="emitter('usersettings', slotProps.close)"
      >
        {{ $t('Profile settings') }}
      </div>
      <div
        class="drop-link w-dropdown-link pointer"
        @click="emitter('teamsettings', slotProps.close)"
      >
        {{ $t('Company information') }}
      </div>
      <div class="drop-link w-dropdown-link pointer" @click="emitter('logout', slotProps.close)">
        {{ $t('Log out') }}
      </div>
    </template>
  </Dropdown>
</template>

<script>
  import ChevronIcon from '@/assets/icons/chevron-down.svg';
  import Avatar from '@/components/avatars/Avatar';
  import { IuiDropdown as Dropdown } from 'industrial-ui-vue';

  export default {
    name: 'SidebarSettings',
    components: {
      Dropdown,
      Avatar,
      ChevronIcon,
    },
    props: {
      user: {
        type: Object,
        default: () => ({}),
      },
      active: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      name() {
        return this.user.name?.trim().split?.(' ')?.[0];
      },
    },
    methods: {
      emitter(event, close = null) {
        this.$emit(event);
        close?.();
      },
    },
  };
</script>

<style lang="scss">
  @import 'src/styles/colors';

  .name-company {
    width: 160px;

    &__title {
      font-weight: 700;
      font-size: 14px;
      color: $grey700;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .small-text {
      color: $grey700;
      font-size: 14px;
      font-weight: 400;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .profile-menu-info {
    display: flex;
    align-items: center;
  }

  .profile-menu-info__icon {
    width: 20px;
  }
</style>
